import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, ChevronLeft, ChevronRight } from 'lucide-react';
import NoteCard from '../NoteCard';
import type { Note, Pagination } from '../../hooks/useApi';

type Props = {
  notes: Note[];
  loading: boolean;
  error: string | null;
  pagination: Pagination | null;
  page: number;
  onPageChange: (page: number) => void;
  hasFilters: boolean;
};

const NotesResultsGrid: React.FC<Props> = ({
  notes,
  loading,
  error,
  pagination,
  page,
  onPageChange,
  hasFilters,
}) => {
  const totalPages = pagination?.pages ?? 1;

  if (loading) {
    return (
      <div className="notes-results-grid notes-results-grid--loading">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="note-skeleton" aria-hidden />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="glow-card empty-state">
        <AlertCircle size={36} color="#ef4444" style={{ marginBottom: '12px' }} />
        <p>{error}</p>
      </div>
    );
  }

  if (notes.length === 0) {
    return (
      <div className="glow-card empty-state">
        <p>
          {hasFilters
            ? 'Bu kriterlere uygun onaylı not bulunamadı. Filtreleri genişletmeyi deneyin.'
            : 'Henüz onaylı not yok.'}
        </p>
        <Link to="/notlar/yukle" style={{ color: 'var(--accent-primary)', fontWeight: 600, fontSize: '14px' }}>
          İlk notu sen yükle →
        </Link>
      </div>
    );
  }

  return (
    <>
      <div className="notes-results-grid">
        {notes.map((note, index) => (
          <NoteCard key={note._id} note={note} index={index} />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="notes-pagination">
          <button type="button" disabled={page <= 1} onClick={() => onPageChange(Math.max(1, page - 1))}>
            <ChevronLeft size={18} />
            Önceki
          </button>
          <span>
            {page} / {totalPages}
          </span>
          <button type="button" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
            Sonraki
            <ChevronRight size={18} />
          </button>
        </div>
      )}
    </>
  );
};

export default NotesResultsGrid;
